module.exports = __webpack_public_path__ + "static/omega-293f5e6a41c5037d942d56db6ac5e20b.png";